import { useCallback } from "react";
import { Pressable, Linking, StyleSheet } from "react-native";
import { FontAwesomeIcon, tabIconSize, logError } from "../platform";
import { faSafari } from "@fortawesome/free-brands-svg-icons";
import AppStore from "../storage/appStore";
import { STRINGS } from "../constants/strings";

const HeaderWebView = ({ url, title }) => {
  const setErrorMessage = AppStore((state) => state.setErrorMessage);

  const handleLinkPress = useCallback(async () => {
    if (url) {
      try {
        await Linking.openURL(url);
      } catch (error) {
        logError("link_open_failed", {
          message: error.message,
          stack: error.stack,
          url: url,
          name: title,
        });
        setErrorMessage(STRINGS.failedToOpenLink);
      }
    }
  }, [url, title, setErrorMessage]);

  return (
    <Pressable
      testID="header-webview-button"
      onPress={handleLinkPress}
      style={styles.headerButton}
      accessibilityLabel={`Open ${title || 'link'} in browser`}
      accessibilityRole="button"
    >
      <FontAwesomeIcon icon={faSafari} size={tabIconSize} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  headerButton: {
    paddingRight: 15,
  },
});

export default HeaderWebView;
